import HomeTop from "./HomeTop";
import HomeNav from "./HomeNav";
import HomeContent from "./Home";

const Home = () => {
  return (
    <>
      <HomeTop />
      <HomeNav />
      <HomeContent />
    </>
  );
};

export default Home;
